// extracted by mini-css-extract-plugin
module.exports = {"css":"ProductAccessoriesDisplay_css__8oULP"};